'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const tslib_es6 = require('../../../../tslib.es6-CZ43up4V.js');
const cookies = require('@zapier/cookies');
const eventsToolkitBrowser = require('@zapier/events-toolkit-browser');

const setCookie = (id, value, maxAge, path = "/") => {
  try {
    cookies.writeCookie(id, value, {
      // Cookies are categorized as `essential` for backwards compatibility,
      // but devs should use `writeCookie` from `@zapier/cookies` with
      // the correct `category`.
      category: "essential",
      maxAge,
      path
    });
  } catch (e) {
    console.error("Unable to set cookie", {
      id
    });
  }
};
const getCookie = (id) => {
  try {
    return cookies.readCookie(id);
  } catch (e) {
    return void 0;
  }
};
const UserInteractionEvent = "web_analytics.tracking.user_interaction.UserInteractionEvent";
const emitUserInteractionEvent = async (_a) => {
  var eventDetails = tslib_es6.__rest(_a, []);
  return await eventsToolkitBrowser.emit(Object.assign(Object.assign({}, eventDetails), { absolute_url: window.location.pathname, referrer: document.referrer, system_name: "design_system" }), UserInteractionEvent);
};

exports.default = setCookie;
exports.emitUserInteractionEvent = emitUserInteractionEvent;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
//# sourceMappingURL=utils.cjs.js.map
